<template>
  <div>
    <el-form inline>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" icon="el-icon-plus" @click="add"></el-button>
          <el-button type="primary" icon="el-icon-delete" @click="deleteData"></el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="输入任务号或者任务说明关键字" v-model="searchValue" style="margin-left:150px;">
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
      </el-form-item>
    </el-form>
    <edit ref='edit' :data="data" @refreshTable="refreshTable"></edit>
  </div>
</template>

<script>
  import Edit from "@/components/PeriodTask/Edit";
  export default {
    components: {
      Edit
    },
    props: ["deletelist"],
    methods: {
      deleteData() {
        if (this.deletelist && this.deletelist.length > 0) {
          this.$confirm(
            `${this.deletelist.length}条周期任务将被删除,执行这${this.deletelist.length==1?'个':'些'}周期任务的设备的任务将被置空，是否继续?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            this.$getJSON("/task/d_period_tasklst", {
              id_list: JSON.stringify(this.deletelist)
            }).then(res => {
              this.refreshTable();
              this.$message({
                type: "success",
                message: "删除成功"
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },

      search() {
        this.$emit("search");
      },

      add() {
        this.$refs["edit"].show();
      },

      refreshTable() {
        this.$emit("refreshTable");
      }
    },
    data() {
      return {
        searchValue: "",
        data: {}
      };
    }
  };

</script>

<style scoped>
  .el-row {
    margin-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/PeriodTask/ToolBar.vue